import { Infinity as InfinityIcon } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";
import { Eyebrow, StartFreeButton } from "@/components/landing/shared";
import { OccasionGrid } from "@/components/gift/OccasionPicker";

export const GiftSection = () => {
  const navigate = useNavigate();
  return (
  <section data-testid="landing-gift" className="bg-[#FDF7EB] py-20">
    <div className="mx-auto grid max-w-6xl items-center gap-10 px-5 sm:px-6 lg:grid-cols-[2fr_3fr]">
      <div>
        <Eyebrow color="#C58F28">Gift option</Eyebrow>
        <h2 className="mt-3 font-serif text-3xl text-[#2D2824] sm:text-4xl">A gift that grows with them</h2>
        <div className="mt-4 max-w-md space-y-3 text-sm leading-relaxed text-[#6E665E]">
          <p>Your Life Journeys Matter can be given as a meaningful gift for birthdays, graduations, weddings, Mother's Day, Father's Day, retirement or as a portable journal while travelling on holiday.</p>
          <p>Parents can begin recording memories for their children, then hand the account over when they are older so they can continue their own story.</p>
          <p>Grandparents and great grandparents can also preserve their memories, family stories, values and life lessons for the people they love. It gives them a lasting way to be remembered and helps future generations understand who they were, how they lived and the love they carried for their family.</p>
        </div>
        <p className="mt-4 text-sm font-medium text-[#C58F28]">Tap an occasion to start a gift with matching wording.</p>
        <button data-testid="gift-cta" onClick={() => navigate("/gift")} className="mt-6 rounded-full border-2 border-[#E06D53] px-6 py-3 text-sm font-semibold text-[#E06D53] transition-colors hover:bg-[#E06D53] hover:text-white">
          Give a life journey
        </button>
      </div>
      <div data-testid="gift-occasions">
        <OccasionGrid onPick={(g) => navigate(`/gift?occasion=${g.id}`)} testPrefix="landing-occasion" cols="grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" />
      </div>
    </div>
  </section>
  );
};

export const LifetimeInvite = () => (
  <section data-testid="landing-lifetime" className="px-4 py-20 sm:px-6">
    <div className="mx-auto max-w-4xl rounded-[28px] bg-[#2D2824] p-8 text-center sm:p-12">
      <InfinityIcon size={36} weight="duotone" className="mx-auto text-[#D9A036]" />
      <h2 className="mt-4 font-serif text-3xl text-[#FAF6F0] sm:text-4xl">Continue your whole life story</h2>
      <p className="mx-auto mt-3 max-w-xl leading-relaxed text-[#CFC6BB]">
        When you're ready, Lifetime Access opens every Life Season — Teenage Years to Seniors and beyond — with one payment and no subscription.
      </p>
      <p className="mx-auto mt-3 max-w-xl text-sm text-[#CFC6BB]">Start with Childhood free — you can unlock every season whenever you're ready.</p>
      <StartFreeButton testId="lifetime-start" className="mt-8 w-full sm:w-auto" />
    </div>
  </section>
);
